import React from 'react';
import './style.less';
import { useSelector } from 'react-redux';
import { AppState } from 'shared/store/reducers';
import EmptyAvatar from 'shared/components/EmptyAvatar';
import { Icon } from 'shared/components/Icon';
import { ContactInfo } from '../ContactInfo';
import { ConnectedCallSocials } from '../ConnectedCallSocials';

export const ConnectedCallDetailProfile = () => {
  const { detailTask } = useSelector((state: AppState) => state.outbound);

  const contact = detailTask?.contact;

  const name = contact?.name || 'N/A';
  const title = `${contact?.title || contact?.customMetadata?.title || 'Unknown Title'}`;
  const company = `${contact?.company?.name || 'Unknown Company'}`;
  const location = contact?.company?.location || 'Unknown Location';

  return (
    <div className="ConnectedCallDetailProfile">
      <div className="ConnectedCallDetailProfile__summary">
        <div className="ConnectedCallDetailProfile__summary-inner">
          <EmptyAvatar
            className="ConnectedCallDetailProfile__avatar"
            name={name}
            size={48}
            id={contact?.id ?? ''}
          />
          <ConnectedCallSocials />
        </div>
        <div className="ConnectedCallDetailProfile__content">
          <h1 className="ConnectedCallDetailProfile__name">{name}</h1>
          <p className="ConnectedCallDetailProfile__title">{title}</p>
        </div>

        <div className="ConnectedCallDetailProfile__content">
          <div className="ConnectedCallDetailProfile__content-item">
            <Icon icon="companies2" />
            {company}
          </div>
          <div className="ConnectedCallDetailProfile__content-item">
            <Icon icon="pinOutline" />
            {location}
          </div>
        </div>
      </div>
      <ContactInfo />
    </div>
  );
};
